import { dispatchAction } from '@ardoq/rxbeach';
import { updateViewSettings, viewSettingsConsts } from '@ardoq/view-settings';
import { ViewIds } from '@ardoq/api-types';

export type UpdatePersistedViewLegendSettingsArgs = {
  viewId: ViewIds;
  isActive: boolean;
  persistent?: boolean;
};

const updateViewLegendSettings = ({
  viewId,
  isActive,
  persistent = true,
}: UpdatePersistedViewLegendSettingsArgs) =>
  dispatchAction(
    updateViewSettings({
      viewId,
      settings: {
        [viewSettingsConsts.IS_LEGEND_ACTIVE]: isActive,
      },
      persistent,
    })
  );

export const viewLegendCommands = {
  updateViewLegendSettings,
};
